/**
 * Save a file the API sent back, named from its Content-Disposition. The
 * older download actions in store/appStore.js each spell this out; new ones
 * use this.
 */
export function saveBlobResponse(response, fallbackName, type) {
  const disposition = response.headers['content-disposition'] || '';
  const match = disposition.match(/filename="?([^";]+)"?/);
  const url = window.URL.createObjectURL(new Blob([response.data], type ? { type } : undefined));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', match ? match[1] : fallbackName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
